export function safeParseFloat<T>(value: string, defaultValue: number | T): number | T {
    // so we don't display NaN
    const result = parseFloat(value);
    return isNaN(result) ? defaultValue : result;
}
